import { Component, Inject, output, signal } from '@angular/core';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { DIALOG_DATA, DialogRef } from '@shared/component.dialog';
import { NgOtpInputModule } from 'ng-otp-input';
import { OtpConfigurationData } from './otp.interface';
import { NumberMaskingPipe } from '@shared/pipes/number-masking.pipe';
import { OtpCountdownComponent } from './components/otp-countdown/otp-countdown.component';
@Component({
  selector: 'app-otp',
  standalone: true,
  imports: [TranslateModule, NgOtpInputModule, NumberMaskingPipe, TranslatePipe, OtpCountdownComponent],
  templateUrl: './otp.component.html',
  styleUrl: './otp.component.scss'
})
export class OtpComponent {
  submitOTP = output<string>();
  resendOTP = output<void>();

  otp = signal<string>('');

  isCountdownFinished = signal<boolean>(false);

  constructor(
    @Inject(DIALOG_DATA) public data:OtpConfigurationData,
    private readonly dialogRef: DialogRef
  ){
  }

  get isButtonActive() {
    return this.otp().length < this.data.otpCount;
  }

  onClickSubmit() {
    this.submitOTP.emit(this.otp());
  }

  onClickClose() {
    this.dialogRef.close();
  }
}
